export default {
  home: '首頁',
  login: '登錄',
  system_setting: '系統配置',
  menu_setting: '菜單維護',
  user_setting: '用戶管理',
  auth_setting: '權限管理',
  logs: '操作日誌',
  apps_setting: '應用接入',
  apps_group: '應用分組',
  apps_list: '應用列表',
  interface_setting: '接口設置',
  interface_group: '接口分組',
  interface_list: '接口列表',
  add_button: '新增',
  find_button: '查詢',
  refresh_button: '刷新',
  delete_button: '刪除',
  edit_button: '編輯',
  open_choose: '啟用',
  close_choose: '禁用',
  show_choose: '顯示',
  hide_choose: '隱藏',
  interface_request: '請求參數',
  interface_response: '返回參數',
  user_center: '個人中心',
  wiki_list: '文檔中心',
  wiki_error: '錯誤碼',
  wiki_calculation: '算法詳解',
  wiki_login: '文檔登錄'
}
